import React from 'react';
import cx from 'classnames';
import WidgetPreviewTitle from '../../WidgetPreviewTitle';
import WidgetPreviewStoreSwipeLayout from '../WidgetPreviewStoreSwipeLayout';
import WidgetPreviewStoreItem from '../WidgetPreviewStoreItem';
import { WIDGET_LAYOUT_TYPE, WIDGET_TYPE } from '../../../../../../constants/service/app/widgetConstants';
import './WidgetPreviewStoreWrap.scss';

const WidgetPreviewStoreWrap = (props) => {
  const { widgetInfo, exposureWidgetItemList } = props;
  const { layoutType, mainTitle, isUsedSubTitle, subTitle } = widgetInfo;

  return (
    <div className="widget-preview-store-wrap">
      {
        /**
         *  위젯 타이틀, 위젯 서브 타이틀
         */
        <WidgetPreviewTitle mainTitle={mainTitle} isUsedSubTitle={isUsedSubTitle} subTitle={subTitle} />
      }

      <div className="widget-store-item-list">
        <div
          className={cx(
            'widget-store-section',
            /**
             *  그리드 1 X 4
             */
            layoutType === WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_1_X_4 ? 'grid-1-x-4' : '',
            /**
             *  그리드 2 X 2
             */
            layoutType === WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].GRID_2_X_2 ? 'grid-2-x-2' : '',
            /**
             *  스크롤 N X 1 (이미지 margin 존재)
             */
            layoutType === WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_MARGIN_N_X_1 ? 'scroll-margin-n-x-1' : '',
            /**
             *  스크롤 N X 1 (이미지 margin 존재하지 않음)
             */
            layoutType === WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SCROLL_NO_MARGIN_N_X_1 ? 'scroll-no-margin-n-x-1' : '',
            /**
             *  스와이프
             */
            layoutType === WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SWIPE ? 'swipe' : '',
          )}
        >
          {layoutType === WIDGET_LAYOUT_TYPE[WIDGET_TYPE.BRAND].SWIPE ? (
            <WidgetPreviewStoreSwipeLayout list={exposureWidgetItemList} layoutType={layoutType} />
          ) : (
            exposureWidgetItemList.map((storeItem, index) => (
              <WidgetPreviewStoreItem key={index} layoutType={layoutType} storeItem={storeItem} />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default WidgetPreviewStoreWrap;
